import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeTheme } from '../reducers/theme/theme-reducer';
import selectTheme from '../reducers/theme/theme-selectors';
import { Theme } from '../reducers/theme/theme-types';
var useTheme = function () {
    var theme = useSelector(selectTheme());
    var dispatch = useDispatch();
    var setTheme = function (newTheme) {
        document.documentElement.setAttribute('data-theme', newTheme);
        localStorage.setItem('theme', newTheme);
    };
    var toggleTheme = function () {
        var newTheme = theme === Theme.DARK ? Theme.LIGHT : Theme.DARK;
        dispatch(changeTheme(newTheme));
        setTheme(newTheme);
    };
    useEffect(function () {
        setTheme(theme);
    }, []);
    return { toggleTheme: toggleTheme, theme: theme };
};
export default useTheme;
